import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TSearchSubmitEventParams } from './_types';

export const searchSubmitEvent = (params: TSearchSubmitEventParams) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.SEARCH_SUBMIT,
    params,
  });
};
